import { useCallback, useEffect, useMemo, useState } from "react"
import { visibleFormPages, type FormAnswerLike } from "~/lib/forms"

export function useFormPagination(
	content: string | null | undefined,
	setErrors: (errors: Record<string, string>) => void,
	answers: FormAnswerLike[]
) {
	const visible = useMemo(
		() => visibleFormPages(content, answers),
		[content, answers]
	)
	const pages = useMemo(
		() => visible.map((page) => page.questionIds),
		[visible]
	)
	const [selectedPage, setSelectedPage] = useState(0)
	const selected = visible.findIndex((page) => page.index === selectedPage)
	const page =
		selected >= 0
			? selected
			: visible.reduce(
					(last, candidate, index) =>
						candidate.index < selectedPage ? index : last,
					0
				)
	const pageIndex = visible[page]?.index ?? 0
	useEffect(() => {
		if (selectedPage !== pageIndex) setSelectedPage(pageIndex)
	}, [selectedPage, pageIndex])
	const setPage = useCallback(
		(next: number) => setSelectedPage(visible[next]?.index ?? 0),
		[visible]
	)
	return { pages, page, pageIndex, setPage, setErrors }
}
